import React, { useState, useEffect } from 'react'
import MultiStep from '../../../../assets/components/multistep/MultiStep'
import PageHeader from '../../../../assets/components/pageheader/PageHeader';
import UserIcon from '../../../../assets/images/user_header_icon.png'
import Contact from './Contact';
import { TransitionGroup } from 'react-transition-group';
import Demographics from './Demographics';
import EmploymentDetails from './EmploymentDetails';
import ArrowLeft from '../../../../assets/images/arrow_left.png'
import { useNavigate, useParams, useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert'
import { editUserDetails, getUserDetails } from '../../../../actions/user_action';
import ViewResearcher from './View_Researcher';
import Listing from '../../../../assets/components/listing/Listing'
import Loader from "react-loaders";
import LoadingOverlay from 'react-loading-overlay-ts';
import { Card, CardBody} from "reactstrap";
import ResizeDetector from "react-resize-detector";

const UserInfo = () => {
    const history = useNavigate()
    const location = useLocation();
    const currentPath = location.pathname;
    const [isLoading, setLoading] = useState(true)
    const [isEdit, setEditMode] = useState(false)
    const params = useParams()
    const dispatch = useDispatch()
    const userState = useSelector(state => state.User)
    const [userDetails, setUserDetails] = useState({})
    const [userRewardsHistory, set_userRewards] = useState({})


const [userColumns, setUserColumn] = useState([
        
        { Name: "Reward Brand", Type: 'string', key: 'rewardBrand', fixWidth: 1 },
        { Name: "Reward Cash", Type: 'string', key: 'rewardCash', fixWidth: 1 },
        { Name: "Redeem Points", Type: 'number', key: 'rewardPoints', fixWidth: 10 },
        { Name: "Applied At", Type: 'number', key: 'rewardDate' },
         { Name: "Status", Type: 'string', key: 'rewardStatus' },
         { Name: "Redeemed At", Type: 'number', key: 'redeemedDate' },
       
    ])



    const onEditUserDetails = () => {
        dispatch(editUserDetails(params.userId, userDetails))
            .then(response => {
                Swal({
                    title: response.payload.title ? response.payload.title : "Edited",
                    text: response.payload.message ? response.payload.message : 'User Details edited',
                    icon: 'success'
                })
            })
            .catch(err => {
                Swal({
                    title: err.response ? err.response.data.name : "Error",
                    text: err.response ? err.response.data.content : "Please try again",
                    icon: 'error'
                })
            })
    }


    const steps = [
        { name: "Contact Details", component: <Contact userDetails={userDetails} setUserDetails={setUserDetails} isEdit={isEdit} editUser={() => onEditUserDetails()} /> },
        { name: "Demographics", component: <Demographics userDetails={userDetails} setUserDetails={setUserDetails} isEdit={isEdit} editUser={() => onEditUserDetails()} /> },
        { name: "Employment Details", component: <EmploymentDetails userDetails={userDetails} setUserDetails={setUserDetails} isEdit={isEdit} editUser={() => onEditUserDetails()} /> },
    ];



    useEffect(() => {
        dispatch(getUserDetails(params.userId))
            .then(response => {
                //console.log('res ->', response.payload.content)
                setUserDetails(response.payload.content)
                set_userRewards(response.payload.rewards)
                setLoading(false)
            })
            .catch(err => {
                setLoading(false)
                Swal({
                    title: err.response ? err.response.data.name : "Error",
                    text: err.response ? err.response.data.content : "Something went wrong",
                    icon: 'error'
                }).then(() => history('/admin/users'))
            })
    }, []);

    useEffect(() => {
        if (currentPath === `/admin/edit-user/${params.userId}`) {
            setEditMode(true)
        }
    })

    return (

         <ResizeDetector
            handleWidth
            render={({ width }) => (
        <TransitionGroup component="div" transitionName="TabsAnimation" transitionAppear={true}
            transitionAppearTimeout={0} transitionEnter={false} transitionLeave={false}>

            {/* Page Header */}
            <div className="admin_header">
                {
                    isEdit ?
                        <PageHeader heading="User Personal Information" img={UserIcon} />
                        :
                        <PageHeader heading="User Personal Information" img={UserIcon}
                            btnText="Edit"
                            btnClick={() => setEditMode(true)}
                        />
                }

            </div>
            {location.pathname.includes('rewards') ?

                <span onClick={() => history("/admin/rewards")} style={{ cursor: 'pointer' }}>
                    <img src={ArrowLeft} alt="" width="8px" />
                    <label style={{ cursor: 'pointer' }} className="ml-2">Back</label>
                </span> : 

                <span onClick={() => history("/admin/user")} style={{ cursor: 'pointer' }}>
                    <img src={ArrowLeft} alt="" width="8px" />
                    <label style={{ cursor: 'pointer' }} className="ml-2">Back</label>
                </span>}
            {/* Back Icon */}
            {/* <span onClick={() => history("/admin/user")} style={{ cursor: 'pointer' }}>
                <img src={ArrowLeft} alt="" width="8px" />
                <label style={{ cursor: 'pointer' }} className="ml-2">Back</label>
            </span> */}

            {/* Form Steps */}
            {
                !isLoading && userDetails.role &&
                <div>
                    {
                        userDetails.role === 3 ?
                            <MultiStep showNavigation={true} steps={steps} />
                            :
                            <ViewResearcher userDetails={userDetails} setUserDetails={setUserDetails} editUser={() => onEditUserDetails()} isEdit={isEdit} />
                    }
                </div>

            }
            {userRewardsHistory && userRewardsHistory.length > 0 &&
             <Card className="main-card my-4">
                        <nav className="navbar navbar-expand-sm navbar-light" style={{ backgroundColor: '#006FA7', borderRadius: '5px 5px 0 0' }}>
                            <div className="text-white menu-header-title text-capitalize">User Applied Rewards List</div>

                            <div className={width > 470 && "collapse navbar-collapse"}>
                                <ul className="navbar-nav mr-auto" >
                                </ul>
                                {/* <form className="form-inline my-2 my-lg-0" style={{ marginRight: '-2.5rem' }}>
                                    <div className="input-group input-group-sm w-75">
                                        <div className="input-group-prepend border-0">
                                            <span className={`bg-white my-sm-0 input-group-text form-control-sm ${styles.search_input}`}> <img src={Search} alt="search" /></span>
                                        </div>
                                        <input className={`form-control input-sm mr-sm-2 p-0 m-0 border-left-0 form-control-sm ${styles.search_input}`} type="search" placeholder="Search" aria-label="Search" style={{ borderTopLeftRadius: '0' }} onChange={(e) => setSearchString(e.target.value)} />
                                    </div>

                                </form> */}
                            </div>
                        </nav>

                        <CardBody className="p-0" >
                            <LoadingOverlay tag="div" active={isLoading}
                                styles={{
                                    overlay: (base) => ({
                                        ...base,
                                        background: "#fff",
                                        opacity: 0.5,

                                    }),
                                }}
                                spinner={
                                    <Loader color="#6c757d" active type="ball-pulse" />
                                }>
                                <CardBody className="p-0">

                                    {/* Listing */}
                                    <div className="table_border">
                                        <Listing columnName={userColumns}
                                            //data={(searchString.length > 0 && searchedUser.length > 0) ? searchedUser : userData}
                                            data={userRewardsHistory && userRewardsHistory.length > 0 ? userRewardsHistory: <p>No rewards history</p>}

                                            //currentPage={userState && userState.currentPage ? userState.currentPage : 1}
                                            //totalPages={userState && userState.totalPages ? userState.totalPages : 1} finalPoints={userState && userState.finalPoints ? userState.finalPoints : 0}
                                            //getListingData={(currentPage, dataLimit) => getUserListing(currentPage, dataLimit)}
                                            //startLoading={() => setLoading(true)}
                                        />
                                    </div>

                                </CardBody>
                            </LoadingOverlay>
                        </CardBody>
                    </Card>
             }

        </TransitionGroup>
         )}
        />
    )
}

export default UserInfo
